import React from 'react';
import Contacts_Comp from '../../Components/Contacts/Contacts';
import Dashboard_Comp from '../../Components/Dashboard/Dashboard';

function Contacts() {
  return (
    <Dashboard_Comp>
    <Contacts_Comp />
    </Dashboard_Comp>
  )
}

export default Contacts;